import { render, staticRenderFns } from "./visit-batch-approved.vue?vue&type=template&id=78eaca3b"
import script from "./visit-batch-approved.vue?vue&type=script&lang=ts"
export * from "./visit-batch-approved.vue?vue&type=script&lang=ts"
import style0 from "./visit-batch-approved.vue?vue&type=style&index=0&id=78eaca3b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports